var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStatusCheckPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.347 18.498L4.646 12.798L6.071 11.373L10.347 15.648L19.522 6.47299L20.947 7.89799L10.347 18.498Z",
    fill: "#00BCE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStatusCheckPrimary);
export default __webpack_public_path__ + "static/media/ic-status-check-primary.ec5e109adf8c405d0b348c8eb3ad61ad.svg";
export { ForwardRef as ReactComponent };